export const calculateVisibleCount = (
	container: HTMLElement,
	itemWidths: number[],
	buttonWidth: number,
): number => {
	if (itemWidths.length === 0) {
		return 0;
	}

	const containerWidth = container.offsetWidth;
	const firstItemWidth = itemWidths[0];

	let usedWidth = firstItemWidth + buttonWidth;
	let count = 1;

	for (let i = 1; i < itemWidths.length; i++) {
		if (usedWidth + itemWidths[i] > containerWidth) {
			break;
		}

		usedWidth += itemWidths[i];
		count++;
	}

	return count;
};
